import ActionTypes from './ActionTypes';

const initialState = {
  isOpen: false,
  data: {
    client: null,
    email: '',
    subject: '',
    content: '',
    attachments: [],
    clientSelectDisabled: false,
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SHOW_MODAL:
      return {
        isOpen: true,
        data: {
          ...state.data,
          ...action.data,
        }
      }
    case ActionTypes.HIDE_MODAL:
      return initialState
    default:
      return state
  }
}
